// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__xvC8B","content":"Layout_content__hZcBN"};